<template>
  <div style="margin-top:15px;" class="block">
    <el-pagination @current-change="handleCurrentChange"
      :current-page.sync="msgToChild.pageIndex" :page-size="10" layout="total, prev, pager, next" :total="msgToChild.Counts">
    </el-pagination>
  </div>
</template>
<script>
export default {
  props:['msgToChild'],
  data() {
    return {

    }
  },
  mounted() {
    console.log(this.msgToChild)
  },
  methods: {
    handleCurrentChange(val) {
      this.msgToChild.pageIndex = val;
      console.log(this.msgToChild)
      this.$emit('send',this.msgToChild)
    },
  },
  destroyed() {
    
  }
}
</script>